import { render, staticRenderFns } from "./tabnav.vue?vue&type=template&id=f99bd41c&scoped=true&"
import script from "./tabnav.vue?vue&type=script&lang=js&"
export * from "./tabnav.vue?vue&type=script&lang=js&"
import style0 from "./tabnav.vue?vue&type=style&index=0&id=f99bd41c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f99bd41c",
  null
  
)

export default component.exports